/* Plastics Co cart drawer (pcob-*).
   The theme's Cart class (theme.js) still opens / closes #mini-cart and re-renders its inner HTML
   after "Add to cart". This script adds: quantity changes and removal through the Cart AJAX API
   (re-rendering the mini-cart section in the same request), undo, promo / discount codes, the
   live UK delivery rate, dispatch countdown, related products and an "Added" confirmation.
   A MutationObserver on #mini-cart re-applies everything after any re-render, ours or the theme's.
   Messages are placed inside the theme's cart element, because the theme closes the drawer on
   any click outside it. */
(function () {
  if (window.PCOB) return;
  window.PCOB = true;

  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var fmt = new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' });
  var DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  var ICON_TAG = '<svg class="pcob-i" viewBox="0 0 24 24" aria-hidden="true"><path d="M20.6 13.4l-7.2 7.2a2 2 0 0 1-2.8 0L3 13V3h10l7.6 7.6a2 2 0 0 1 0 2.8z"/><circle cx="7.5" cy="7.5" r="1.5"/></svg>';

  function money(cents) { return fmt.format(cents / 100); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return [].slice.call((ctx || document).querySelectorAll(sel)); }
  function drawer() { var d = document.getElementById('mini-cart'); return d && d.hasAttribute('data-pcob') ? d : null; }
  function isOpen() { var d = drawer(); return d && d.getAttribute('aria-hidden') === 'false'; }
  /* The theme's cart element: clicks inside it don't close the drawer */
  function host() { var d = drawer(); return (d && d.closest('.header__action-item--cart')) || document.body; }

  function post(path, body) {
    return fetch(ROOT + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok || j.status === 422 || j.status === 404) throw new Error(j.description || j.message || 'Something went wrong. Please try again.');
        return j;
      });
    });
  }
  /* Cart change + the re-rendered drawer in one round trip */
  function cartPost(path, body) {
    body.sections = ['mini-cart'];
    body.sections_url = location.pathname;
    return post(path, body).then(function (res) { apply(res.sections && res.sections['mini-cart']); return res; });
  }

  /* ---------- Re-render ---------- */
  function apply(html) {
    var d = drawer();
    if (!d) return;
    if (!html) {
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { scrollToTop: false } }));
      return;
    }
    var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('.mini-cart');
    if (!fresh) return;
    /* Keep scroll position and keyboard focus across the swap */
    var body = $('.pcob__body', d), top = body ? body.scrollTop : 0;
    var focus = null, a = document.activeElement;
    if (a && d.contains(a)) {
      var li = a.closest('[data-pcob-line]');
      focus = { key: li && li.getAttribute('data-key'), step: a.getAttribute('data-pcob-step'), input: a.hasAttribute('data-pcob-input') };
    }
    var codeOpen = $('[data-pcob-code-form]', d) && $('[data-pcob-code-form]', d).open;
    d.innerHTML = fresh.innerHTML;
    var count = fresh.getAttribute('data-item-count');
    d.setAttribute('data-item-count', count);
    $$('.header__cart-count').forEach(function (el) { el.textContent = count; });
    var nb = $('.pcob__body', d);
    if (nb) nb.scrollTop = top;
    if (codeOpen && $('[data-pcob-code-form]', d)) $('[data-pcob-code-form]', d).open = true;
    if (focus) {
      var line = focus.key && $('[data-pcob-line][data-key="' + focus.key + '"]', d);
      var target = line && (focus.input ? $('[data-pcob-input]', line) : focus.step ? $('[data-pcob-step="' + focus.step + '"]', line) : null);
      (target || $('.pcob__close', d)).focus();
    }
  }

  /* ---------- Lines ---------- */
  function lineOf(el) { return el.closest('[data-pcob-line]'); }
  function showErr(li, msg) { var e = $('[data-pcob-err]', li); if (e) { e.textContent = msg; e.hidden = false; } }
  function setQty(li, qty) {
    li.classList.add('is-busy');
    return cartPost('cart/change.js', { id: li.getAttribute('data-key'), quantity: qty })
      .then(function (cart) { afterCart(cart); return cart; })
      .catch(function (err) {
        li.classList.remove('is-busy');
        var input = $('[data-pcob-input]', li);
        if (input) input.value = li.getAttribute('data-qty');
        showErr(li, err.message);
      });
  }
  function removeLine(li) {
    var undo = { id: parseInt(li.getAttribute('data-variant'), 10), quantity: parseInt(li.getAttribute('data-qty'), 10) };
    /* Liquid renders "no properties" as [], which cart/add.js rejects; only send real ones */
    var props = JSON.parse(li.getAttribute('data-props') || 'null');
    if (props && !Array.isArray(props) && Object.keys(props).length) undo.properties = props;
    var title = li.getAttribute('data-title');
    setQty(li, 0).then(function (cart) {
      if (cart) toast('Removed <b>' + esc(title) + '</b>', 'Undo', function () {
        return cartPost('cart/add.js', { items: [undo] }).then(refreshCart);
      });
    });
  }
  var commitTimers = {};
  function queueCommit(li, wait) {
    var key = li.getAttribute('data-key');
    clearTimeout(commitTimers[key]);
    commitTimers[key] = setTimeout(function () { commit(li); }, wait);
  }
  function commit(li) {
    var input = $('[data-pcob-input]', li);
    if (!input || !li.isConnected) return;
    var v = parseInt(input.value, 10), cur = parseInt(li.getAttribute('data-qty'), 10);
    var min = parseInt(input.min, 10) || 1, max = parseInt(input.max, 10);
    if (isNaN(v) || v < 0) { input.value = cur; return; }
    if (v === 0) { removeLine(li); return; }
    if (v < min) v = min;
    if (!isNaN(max) && v > max) { v = max; showErr(li, 'Only ' + max + ' available.'); }
    input.value = v;
    if (v !== cur) setQty(li, v);
  }

  /* ---------- Toast (inside the theme's cart element, see top) ---------- */
  function toast(html, actionLabel, action) {
    $$('.pcob-toast').forEach(function (t) { t.remove(); });
    var t = document.createElement('div');
    t.className = 'pcob-toast';
    t.setAttribute('role', 'status');
    t.innerHTML = '<span>' + html + '</span>' + (actionLabel ? '<button type="button">' + esc(actionLabel) + '</button>' : '');
    host().appendChild(t);
    var timer = setTimeout(function () { t.remove(); }, 7000);
    var btn = $('button', t);
    if (btn) btn.addEventListener('click', function (e) {
      e.preventDefault();
      clearTimeout(timer);
      btn.disabled = true;
      action().then(function () { t.remove(); }).catch(function (err) { $('span', t).textContent = err.message; });
    });
  }

  /* ---------- Discount codes ---------- */
  var lastCart = null;
  function refreshCart() {
    return fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { afterCart(cart); return cart; })
      .catch(function () {});
  }
  function afterCart(cart) {
    lastCart = cart;
    renderCodes();
    loadShipping();
  }
  function renderCodes() {
    var d = drawer(), list = d && $('[data-pcob-codes]', d);
    if (!list || !lastCart) return;
    var codes = lastCart.discount_codes || [];
    list.innerHTML = codes.map(function (c) {
      return '<li class="pcob-tag' + (c.applicable ? '' : ' is-bad') + '">' + ICON_TAG + '<span>' + esc(c.code) +
        (c.applicable ? '' : ' <small>not valid here</small>') + '</span>' +
        '<button type="button" data-pcob-unapply="' + esc(c.code) + '" aria-label="Remove code ' + esc(c.code) + '">×</button></li>';
    }).join('');
    var promo = $('[data-pcob-apply]', d);
    if (promo) {
      var p = promo.getAttribute('data-pcob-apply').toLowerCase();
      promo.hidden = codes.some(function (c) { return String(c.code).toLowerCase() === p; });
    }
  }
  function currentCodes() { return ((lastCart && lastCart.discount_codes) || []).map(function (c) { return c.code; }); }
  function setMsg(text, bad) {
    var m = $('[data-pcob-code-msg]');
    if (m) { m.textContent = text; m.classList.toggle('is-bad', !!bad); }
  }
  function applyCode(code) {
    code = String(code || '').trim();
    if (!code) { setMsg('Enter a code first.', true); return; }
    var codes = currentCodes().filter(function (c) { return c.toLowerCase() !== code.toLowerCase(); }).concat(code);
    setMsg('Checking ' + code + '…');
    cartPost('cart/update.js', { discount: codes.join(',') })
      .then(function (cart) {
        afterCart(cart);
        var hit = (cart.discount_codes || []).filter(function (c) { return c.code.toLowerCase() === code.toLowerCase(); })[0];
        if (hit && hit.applicable) setMsg(code.toUpperCase() + ' applied' + (cart.total_discount ? ': you save ' + money(cart.total_discount) : '') + '.');
        else setMsg(code.toUpperCase() + ' isn’t valid for this cart.', true);
      })
      .catch(function (e) { setMsg(e.message, true); });
  }
  function removeCode(code) {
    var codes = currentCodes().filter(function (c) { return c.toLowerCase() !== code.toLowerCase(); });
    cartPost('cart/update.js', { discount: codes.join(',') })
      .then(function (cart) { afterCart(cart); setMsg(code.toUpperCase() + ' removed.'); })
      .catch(function (e) { setMsg(e.message, true); });
  }

  /* ---------- Delivery rate (from the store's own shipping settings) ---------- */
  var shipSeq = 0, lastRates = null;
  function loadShipping() {
    var d = drawer(), dd = d && $('[data-pcob-ship]', d), postcode = d && d.getAttribute('data-ship-postcode');
    if (!dd || !postcode) return;
    var seq = ++shipSeq;
    fetch(ROOT + 'cart/shipping_rates.json?shipping_address[zip]=' + encodeURIComponent(postcode) +
      '&shipping_address[country]=United%20Kingdom&shipping_address[province]=', { credentials: 'same-origin' })
      .then(function (res) { return res.ok ? res.json() : Promise.reject(); })
      .then(function (j) {
        if (seq !== shipSeq) return;
        var rates = (j.shipping_rates || []).map(function (x) {
          return { name: x.name, cents: Math.round(parseFloat(x.price) * 100) };
        }).sort(function (a, b) { return a.cents - b.cents; });
        if (rates.length) { lastRates = rates; showShipping(); }
      })
      .catch(function () {});
  }
  function showShipping() {
    var d = drawer(), dd = d && $('[data-pcob-ship]', d);
    if (!dd || !lastRates) return;
    var r = lastRates[0];
    dd.textContent = r.cents === 0 ? 'Free' : (lastRates.length > 1 ? 'From ' : '') + money(r.cents);
    var name = $('[data-pcob-ship-name]', d);
    if (name) name.textContent = 'UK ' + r.name;
    var totalEl = $('[data-pcob-total]', d);
    var total = parseInt(totalEl.getAttribute('data-cents'), 10) + r.cents;
    totalEl.textContent = money(total);
    $('[data-pcob-total-label]', d).textContent = 'Estimated total';
    var vat = $('[data-pcob-vat]', d), save = vat && $('.pcob-save', vat);
    if (vat) vat.innerHTML = 'Includes ' + money(Math.round(total / 6)) + ' VAT · ' + money(total - Math.round(total / 6)) + ' ex VAT' +
      (save ? '<br><span class="pcob-save">' + esc(save.textContent) + '</span>' : '');
  }

  /* ---------- Dispatch countdown (same rules as the product and cart pages) ---------- */
  function ukNow() {
    var o = {};
    new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/London', year: 'numeric', month: 'numeric', day: 'numeric',
      hour: '2-digit', minute: '2-digit', hour12: false
    }).formatToParts(new Date()).forEach(function (p) { o[p.type] = p.value; });
    return { date: new Date(Date.UTC(+o.year, +o.month - 1, +o.day)), mins: (parseInt(o.hour, 10) % 24) * 60 + parseInt(o.minute, 10) };
  }
  function isWorkday(x) { var w = x.getUTCDay(); return w !== 0 && w !== 6; }
  function addWorkdays(x, n) {
    var y = new Date(x.getTime());
    while (n > 0) { y.setUTCDate(y.getUTCDate() + 1); if (isWorkday(y)) n--; }
    return y;
  }
  function day(x) { return x.toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short', timeZone: 'UTC' }); }
  function renderDispatch() {
    var d = drawer(), el = d && $('[data-pcob-dispatch]', d), txt = el && $('[data-pcob-dispatch-text]', el);
    if (!txt) return;
    var cutoff = (parseInt(el.getAttribute('data-cutoff'), 10) || 14) * 60;
    var minD = parseInt(el.getAttribute('data-min-days'), 10) || 1, maxD = parseInt(el.getAttribute('data-max-days'), 10) || 3;
    var now;
    try { now = ukNow(); } catch (e) { return; }
    var dispatch, html;
    if (isWorkday(now.date) && now.mins < cutoff) {
      dispatch = now.date;
      var left = cutoff - now.mins, h = Math.floor(left / 60), m = left % 60;
      html = 'Order within <strong>' + (h ? h + 'h ' : '') + m + 'm</strong> for <strong>dispatch today</strong>';
    } else {
      dispatch = addWorkdays(now.date, 1);
      var diff = Math.round((dispatch - now.date) / 864e5);
      html = 'Order now for <strong>dispatch ' + (diff === 1 ? 'tomorrow' : 'on ' + DAYS[dispatch.getUTCDay()]) + '</strong>';
    }
    html += '<span class="pcob-dispatch__eta">Estimated delivery ' + day(addWorkdays(dispatch, minD)) + ' – ' + day(addWorkdays(dispatch, maxD)) + '</span>';
    if (txt.innerHTML !== html) txt.innerHTML = html;
  }

  /* ---------- Related products ---------- */
  var recProducts = null, recFor = null;
  function loadRecs() {
    var d = drawer(), box = d && $('[data-pcob-recs]', d);
    if (!box) return;
    var pid = box.getAttribute('data-product');
    if (recProducts && recFor === pid) { fillRecs(box); return; }
    recFor = pid;
    fetch(ROOT + 'recommendations/products.json?product_id=' + pid + '&limit=10&intent=related')
      .then(function (res) { return res.json(); })
      .then(function (j) { recProducts = j.products || []; var b = drawer() && $('[data-pcob-recs]', drawer()); if (b) fillRecs(b); })
      .catch(function () { recProducts = []; });
  }
  function fillRecs(box) {
    var exclude = (box.getAttribute('data-exclude') || '').split(',');
    /* Skip anything under £1: the cut-to-size calculator's 1p variants aren't buyable directly */
    var list = (recProducts || []).filter(function (p) {
      return p.available && p.price_min >= 100 && exclude.indexOf(String(p.id)) === -1;
    }).slice(0, 6);
    if (!list.length) { box.hidden = true; return; }
    $('[data-pcob-recs-list]', box).innerHTML = list.map(function (p) {
      var img = p.featured_image ? p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=240' : '';
      var single = p.variants && p.variants.length === 1 && p.variants[0].available;
      return '<li class="pcob-rec"><a class="pcob-rec__img" href="' + esc(p.url) + '" tabindex="-1">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy" width="130" height="130">' : '') + '</a>' +
        '<a class="pcob-rec__t" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
        '<p class="pcob-rec__p">' + (p.price_varies ? 'From ' : '') + money(p.price_min) + '</p>' +
        (single
          ? '<button type="button" class="pcob-rec__btn" data-pcob-add="' + p.variants[0].id + '" data-title="' + esc(p.title) + '">Add</button>'
          : '<a class="pcob-rec__btn" href="' + esc(p.url) + '">Choose size</a>') + '</li>';
    }).join('');
    box.hidden = false;
  }

  /* ---------- Per-render setup ---------- */
  var justAdded = 0;
  function render() {
    var d = drawer();
    if (!d) return;
    renderDispatch();
    renderCodes();
    showShipping();
    loadRecs();
    var added = $('[data-pcob-added]', d);
    if (added && Date.now() - justAdded < 5000) added.hidden = false;
  }
  function onOpen() {
    render();
    refreshCart();
  }

  /* ---------- Events ---------- */
  document.addEventListener('product:added', function () { justAdded = Date.now(); }, true);

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t.closest || !t.closest('[data-pcob]')) return;
    var el;
    if ((el = t.closest('[data-pcob-step]'))) {
      var li = lineOf(el), input = $('[data-pcob-input]', li);
      var step = parseInt(input.step, 10) || 1;
      var next = (parseInt(input.value, 10) || 0) + step * parseInt(el.getAttribute('data-pcob-step'), 10);
      $('[data-pcob-err]', li).hidden = true;
      if (next < (parseInt(input.min, 10) || 1)) { removeLine(li); return; }
      input.value = next;
      queueCommit(li, 450);
    } else if ((el = t.closest('[data-pcob-remove]'))) {
      removeLine(lineOf(el));
    } else if ((el = t.closest('[data-pcob-apply]'))) {
      applyCode(el.getAttribute('data-pcob-apply'));
    } else if ((el = t.closest('[data-pcob-code-apply]'))) {
      applyCode($('[data-pcob-code-input]').value);
    } else if ((el = t.closest('[data-pcob-unapply]'))) {
      removeCode(el.getAttribute('data-pcob-unapply'));
    } else if ((el = t.closest('[data-pcob-search-go]'))) {
      search();
    } else if ((el = t.closest('[data-pcob-add]'))) {
      el.disabled = true;
      el.textContent = 'Adding…';
      var title = el.getAttribute('data-title');
      cartPost('cart/add.js', { items: [{ id: parseInt(el.getAttribute('data-pcob-add'), 10), quantity: 1 }] })
        .then(function () { refreshCart(); toast('Added <b>' + esc(title) + '</b>'); })
        .catch(function (err) { el.disabled = false; el.textContent = 'Add'; toast(esc(err.message)); });
    }
  });

  function search() {
    var q = $('#pcob-q');
    if (q && q.value.trim()) location.href = ROOT + 'search?type=product&q=' + encodeURIComponent(q.value.trim());
  }

  document.addEventListener('change', function (e) {
    if (e.target.matches && e.target.matches('[data-pcob] [data-pcob-input]')) commit(lineOf(e.target));
  });
  document.addEventListener('input', function (e) {
    var t = e.target;
    if (t.matches && t.matches('[data-pcob] [data-pcob-input]') && t.value !== '') queueCommit(lineOf(t), 900);
  });
  /* Enter must never submit the drawer form (it posts to the cart) */
  document.addEventListener('keydown', function (e) {
    /* Escape closes the drawer (the theme's own toggle) and returns focus to the cart icon */
    if (e.key === 'Escape' && isOpen()) {
      var d = drawer();
      $('.pcob__close', d).click();
      var icon = $$('.header__action-item--cart [data-action="toggle-mini-cart"]').filter(function (b) { return !d.contains(b); })[0];
      if (icon) icon.focus();
      return;
    }
    if (e.key !== 'Enter' || !e.target.closest || !e.target.closest('[data-pcob]')) return;
    var t = e.target;
    if (t.matches('[data-pcob-input]')) { e.preventDefault(); t.blur(); }
    else if (t.matches('[data-pcob-code-input]')) { e.preventDefault(); applyCode(t.value); }
    else if (t.id === 'pcob-q') { e.preventDefault(); search(); }
  });

  /* Watch the drawer: opening (aria-hidden) and every re-render (childList) */
  function watch() {
    var d = drawer();
    if (!d || d.__pcob) return;
    d.__pcob = true;
    new MutationObserver(function (muts) {
      var opened = false, changed = false;
      muts.forEach(function (m) {
        if (m.type === 'attributes') opened = true;
        else changed = true;
      });
      if (opened) {
        var open = isOpen();
        document.documentElement.classList.toggle('pcob-open', open);
        if (open) onOpen();
        else $$('.pcob-toast').forEach(function (t) { t.remove(); });
      }
      if (changed) render();
    }).observe(d, { attributes: true, attributeFilter: ['aria-hidden'], childList: true });
    setInterval(function () { if (isOpen()) renderDispatch(); }, 30000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch);
  else watch();
})();
